import { Component } from '@angular/core';

@Component({
    selector: 'app-features',
    templateUrl: './features.component.html',
    standalone: false
})
export class FeaturesComponent {}
